'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgStepperStepCss = ":host{display:block;padding:24px 24px 16px;cursor:pointer}.stepper-step{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;position:relative}.stepper-step__step{-ms-flex-align:center;align-items:center;border-radius:50%;display:-ms-inline-flexbox;display:inline-flex;font-size:0.75rem;-ms-flex-pack:center;justify-content:center;height:24px;min-width:24px;width:24px;-webkit-transition:0.3s cubic-bezier(0.25, 0.8, 0.25, 1);transition:0.3s cubic-bezier(0.25, 0.8, 0.25, 1);margin-right:8px;background-color:#1867c0 !important;border-color:#1867c0 !important;color:#fff;margin-right:12px}::slotted(h1,h2,h3,h4,h5,h6){margin:5px 0 !important}";

const RgStepperStep = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        this.rgClick = index.createEvent(this, "rg-click", 7);
        // 3. State() variables
        // ---------------------------------------
        this.isActive = false;
        this.isInactive = true;
        // 4. Public Property API
        // ---------------------------------------
        /** Marks step as complete */
        this.complete = false;
        /** Icon to display when step is marked as completed */
        this.completeIcon = "";
        /** Marks step as editable. */
        this.editable = true;
        /** Icon to display when step is editable */
        this.editIcon = "";
        /** Icon to display when step has an error */
        this.errorIcon = "";
    }
    // 6. Component lifecycle events
    // ---------------------------------------
    connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        var stepper = this.host.closest("rg-stepper");
        if (!!stepper) {
            this.stepperEl = stepper;
        }
    }
    // 8. Public methods API
    // ---------------------------------------
    /** todo */
    async toggle(step) {
        this.isActive = step === this.step;
        this.isInactive = step !== this.step;
    }
    // 9. Local methods
    // ---------------------------------------
    handleClick(e) {
        e.stopPropagation();
        this.rgClick.emit();
        if (this.editable) {
            this.stepperEl.stepClick(this.step);
        }
    }
    render() {
        return (index.h(index.Host, { onClick: this.handleClick }, index.h("div", { class: "stepper-step" }, index.h("span", { class: "stepper-step__step" }, this.step), index.h("div", { class: "stepper-step__label" }, index.h("slot", null)))));
    }
    get host() { return index.getElement(this); }
};
RgStepperStep.style = rgStepperStepCss;

exports.rg_stepper_step = RgStepperStep;
